<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on" color="info" small class="mt-n1">mdi-information-outline</v-icon>
    </template>
    <slot>
      {{ text }}
    </slot>
  </v-tooltip>
</template>

<script>
// Component
export default {
  name: 'InfoTooltip',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped></style>
